export { quad as quadToNTriples } from './lib/quad.js'
export { term as termToNTriples } from './lib/term.js'
